import { Container } from '@mui/material';
import React from 'react';

export default function VendorDashboardLayout({ children, maxWidth = 'xl' }) {
  return (
    <Container
      component="section"
      maxWidth={maxWidth}
      sx={{ py: { xs: 3, md: 5 }, px: { xs: 2, sm: 3, lg: 4 } }}
    >
      {children}
    </Container>
  );
}
